import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateDeceasedDetailsCmConstant {
    static PLACEHOLDER_TEXT = SharedConstants.PLACEHOLDER_TEXT;
    static TABLE_LABEL = "Ensure that you capture the deceased name, surname, and, if applicable, the date the surname was modified.";
    static DECEASED_DETAILS_TITLE = "Deceased details";
    static NAME_LABEL = "Name";
    static SURNAME_LABEL = "Surname";
    static START_DATE_LABEL = "Date name and surname given / date changed";
    static BURIAL_FORM_GROUP_NAME = "burialForm";
    static DECEASED_FORM_GROUP_NAME = "deceasedForm";
    static BURIAL_TYPE_CONTROL = "type";
    static NAME_CONTROL = "name";
    static SURNAME_CONTROL = "surname";
    static START_DATE_CONTROL = "startDate";
    static DECEASED_NAMES_CONTROL = "deceasedNames";
    static ACTION_LABEL = "Action";
    static DELETE_ITEM_TITLE = "Delete deceased name";
    static DELETE_DECEASED_NAME_CONFIRM = SharedConstants.REMOVE_MESSAGE + " deceased name(s)?";
    static SHORT_DATE_CONST = "YYYY/MM/d";
    static ADD_DECEASED_NAME_LBEL = "Add deceased name";
    static EDIT_DECEASED_NAME_LBEL = "Edit deceased name";
    static REMOVE_DECEASED_NAME_LBEL = "Remove deceased name";
    ////////////////////////////////////////////////////////////////////////////
    static SEX_LABEL = "Sex";
    static NATIONALITY_LABEL = "Nationality";
    static MAIDEN_NAME_LABEL = "Maiden name";
    static PALCE_OF_BIRTH_LABEL = "Place of birth";
    static PLACE_OF_DEATH_LABEL = "Place of death";
    static PROVINCE_OF_DEATH_LABEL = "Province of death";
    static IDENTITY_TYPE_LABEL = "Identification type";
    static ID_PASSPORT_NUMBER_LABEL = "ID / Passport number";
    static DATE_OF_BIRTH_LABEL = "Date of birth";
    static DATE_OF_DEATH_LABEL = "Date of death";
    static BURIAL_ORDER_LABEL = "Burial order number";
    static SERIAL_NUMBER_LABEL = "Serial number";
    static VERTICAL_POSITION_LABEL = "Vertical position (m)";
    static NAME_OF_THE_UNDERTAKER_LABEL = "Name of undertaker in position (Only if there is no funeral parlour involved)";
    static SEX_CONTROL = "sex";
    static NATIONALITY_CONTROL = "nationality";
    static MAIDEN_NAME_CONTROL = "maidenName";
    static PALCE_OF_BIRTH_CONTROL = "placeOfBirth";
    static PLACE_OF_DEATH_CONTROL = "placeOfDeath";
    static PROVINCE_OF_DEATH_CONTROL = "provinceOfDeath";
    static IDENTITY_TYPE_CONTROL = "idType";
    static ID_PASSPORT_NUMBER_CONTROL = "idNumber";
    static DATE_OF_BIRTH_CONTROL = "dateOfBirth";
    static DATE_OF_DEATH_CONTROL = "dateOfDeath";
    static BURIAL_ORDER_CONTROL = "burialOrderNumber";
    static SERIAL_NUMBER_CONTROL = "serialNo";
    static VERTICAL_POSITION_CONTROL = "verticalPosition";
    static NAME_OF_THE_UNDERTAKER_CONTROL = "undertaker";
    static SA_ID_IDENTIFICATION_TYPE = "SA ID";
    static PAUPER_APPLICATION_TYPE_NAME_METADATA_KEY = "pauperApplicationTypeName";
    static PAUPER_OPTIONAL_FORM_CONTROL_NAMES = [
        CreateDeceasedDetailsCmConstant.NATIONALITY_CONTROL,
        CreateDeceasedDetailsCmConstant.IDENTITY_TYPE_CONTROL,
        CreateDeceasedDetailsCmConstant.ID_PASSPORT_NUMBER_CONTROL,
        CreateDeceasedDetailsCmConstant.DATE_OF_BIRTH_CONTROL,
        CreateDeceasedDetailsCmConstant.PALCE_OF_BIRTH_CONTROL
    ];
    static PAUPER_LEGACY_OPTIONAL_FORM_CONTROL_NAMES = [
        CreateDeceasedDetailsCmConstant.SEX_CONTROL,
        CreateDeceasedDetailsCmConstant.BURIAL_ORDER_CONTROL,
        CreateDeceasedDetailsCmConstant.VERTICAL_POSITION_CONTROL
    ];
    /////////////////////////////////////////////////////////////////////////
    static SEX_PH = "Select sex";
    static NATIONALITY_PH = "Select nationality";
    static PROVINCE_OF_DEATH_PH = "Select province of death";
    static IDENTITY_TYPE_PH = "Select identity type";
    static VERTICAL_POSITION_PH = "Select vertical Position";
    ////////////////////////////////////////////////////////////////////////
    static DATE_CONST = "yyyy-MM-dd";
    static VALIDATION_MESSAGES = {
        sex: {
            required: `Sex ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        nationality: {
            required: `Nationality ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        identificationType: {
            required: `Identification Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        maidenName: {
            required: `Maiden name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        placeOfBirth: {
            required: `Place of birth ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        placeOfDeath: {
            required: `Place of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        provinceOfDeath: {
            required: `Province of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        idType: {
            sex: ` Identification type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        idNumber: {
            required: `ID / Passport number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION} SA ID numbers must be exactly 13 numbers`,
            wrong: `SA ID numbers must be exactly 13 numbers`
        },
        dateOfBirth: {
            required: `Date of birth ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
            wrong: `Date of birth should not be later than today`
        },
        dateOfDeath: {
            required: `Date of death ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
            wrong: `Date of death should be between date of birth and today`
        },
        burialOrderNumber: {
            required: `Burial order number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        serialNo: {
            required: `Serial Number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        verticalPosition: {
            required: `Vertical position ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        name: {
            required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        surname: {
            required: `Surname ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        startDate: {
            required: `Date name or surname given / date changed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
export var DeceasedNamesTableHeaderEnum;
(function (DeceasedNamesTableHeaderEnum) {
    DeceasedNamesTableHeaderEnum["name"] = "Name";
    DeceasedNamesTableHeaderEnum["surname"] = "Surname";
    DeceasedNamesTableHeaderEnum["StartDate"] = "Date name/surname given / date changed";
})(DeceasedNamesTableHeaderEnum || (DeceasedNamesTableHeaderEnum = {}));
export const DeceasedNamesTableHeaderLookup = new Map([
    [DeceasedNamesTableHeaderEnum.name, "name"],
    [DeceasedNamesTableHeaderEnum.surname, "surname"],
    [DeceasedNamesTableHeaderEnum.StartDate, "startDate"],
]);
